// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__2-1RL","counterText":"styles_counterText__Q0FTX"};